<template>
  <div @click="setIsMapOpen(!isMapOpen)" id="mapBtn" class="mob-map-btn">
    <div class="mob-map-btn__wrap">
      <svg>
        <use :xlink:href="isMapOpen ? '#icon-list-light' : '#icon-map-light'"></use>
      </svg>
      {{ isMapOpen ? "List" : "Map" }}
    </div>
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from "pinia";
import {useMapStore} from "../../store/map.ts";

const {isMapOpen} = storeToRefs(useMapStore())
const { setIsMapOpen } = useMapStore();

</script>
